import axios from "axios";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const s = err?.response?.status;
    const code = err?.response?.data?.code;
    if (s === 409 && code === "AMAZON_NOT_LINKED") {
      window.location.href = "/connect-amazon";
      return Promise.reject(err);
    }
    if (s === 401 || s === 403) {
      alert("ログインセッションが切れました。再ログインしてください。");
      localStorage.removeItem("token");
      window.location.href = "/login";
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);

export default api;